import {
  Bestellung,
  Bezahlart,
  Terminart,
  BPAbholungKundeRequest,
  RemoteResult,
  BestellungInsertRequest,
  LoadState,
} from "mangdto"
import router from "@/router"
import store from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import { Validator } from "mangutil"
import BaseLogic from "../base_logic"

export default class KundendatenLogic extends BaseLogic {
  updateLoadState: LoadState = LoadState.Idle

  formValid: boolean = true
  kundeNachname?: string = null
  kundeVorname?: string = null
  _kundeEmail?: string = null
  kundeTelefon?: string = null

  get kundeEmail(): string {
    return this._kundeEmail
  }

  set kundeEmail(newValue: string) {
    if (newValue == null) this._kundeEmail = null
    else this._kundeEmail = newValue.toLowerCase()
  }

  nachnameRules: any[] = [(v) => !!v || "Bitte Nachname angeben"]

  vornameRules: any[] = [(v) => !!v || "Bitte Vorname angeben"]

  emailRules: any[] = Validator.emailValidate

  telefonRules: any[] = [(v) => !!v || "Bitte Telefon angeben"]

  init() {
    this.mainLogic.bestellungPendingListeners.push(() => {
      var ad = this.mainLogic.bestellungPending.abholung
      if (ad.kundeNachname) {
        this.kundeNachname = ad.kundeNachname
      }
      if (ad.kundeVorname) {
        this.kundeVorname = ad.kundeVorname
      }
      if (ad.kundeEmail) {
        this.kundeEmail = ad.kundeEmail
      }
      if (ad.kundeTelefon) {
        this.kundeTelefon = ad.kundeTelefon
      }
    })

    var ad = this.mainLogic.bestellungPending.abholung
    if (ad.kundeNachname) {
      this.kundeNachname = ad.kundeNachname
    }
    if (ad.kundeVorname) {
      this.kundeVorname = ad.kundeVorname
    }
    if (ad.kundeEmail) {
      this.kundeEmail = ad.kundeEmail
    }
    if (ad.kundeTelefon) {
      this.kundeTelefon = ad.kundeTelefon
    }
  }

  weiter() {
    var terminart = this.mainLogic.bestellungPending.terminart

    if (terminart == Terminart.Reservierung) {
      this.mainLogic.bestellungPending.reservierung.kundeNachname =
        this.kundeNachname
      this.mainLogic.bestellungPending.reservierung.kundeVorname =
        this.kundeVorname
      this.mainLogic.bestellungPending.reservierung.kundeTelefon =
        this.kundeTelefon
      this.mainLogic.bestellungPending.reservierung.kundeEmail = this.kundeEmail

      var request = new BestellungInsertRequest()
      var nbd = this.mainLogic.bestellungPending
      var nbdR = nbd.reservierung

      request.terminart = terminart
      request.identifier = store.state.user.identifier
      request.filialeId = nbd.filiale.filialeId
      request.bezahlart = Bezahlart.Barzahlung

      request.createReservierung()
      request.reservierung.kundeNachname = nbdR.kundeNachname
      request.reservierung.kundeVorname = nbdR.kundeVorname
      request.reservierung.kundeTelefon = nbdR.kundeTelefon
      request.reservierung.kundeEmail = nbdR.kundeEmail
      request.reservierung.zeitVon = nbdR.zeitVon
      request.reservierung.zeitBis = nbdR.zeitBis
      request.reservierung.personen = nbdR.anzahlPersonen
      request.reservierung.art = "ONLINE"
      request.reservierung.bestellart = "SELBST"

      Poster.postUser<RemoteResult<Bestellung>>(
        RestPaths.bestellungKundeEinfuegen,
        request,
      ).then((response) => {
        if (response.data.success) {
          router.push({
            name: RouteNames.NEU.RESERVIERUNG_SELECT_VORBESTELLUNG,
          })
        }
      })
    } else if (terminart == Terminart.Abholung) {
      this.updateLoadState = LoadState.Loading

      var krequest = new BPAbholungKundeRequest()
      krequest.id = store.state.user.identifier
      krequest.kundeNachname = this.kundeNachname
      krequest.kundeVorname = this.kundeVorname
      krequest.kundeTelefon = this.kundeTelefon
      krequest.kundeEmail = this.kundeEmail

      Poster.postUser<RemoteResult<any>>(
        RestPaths.bestellungpendingAbholungKunde,
        krequest,
      )
        .then((response) => {
          if (response.data.success) {
            this.updateLoadState = LoadState.Completed
            this.mainLogic.bestellungPending.abholung.kundeNachname =
              this.kundeNachname
            this.mainLogic.bestellungPending.abholung.kundeVorname =
              this.kundeVorname
            this.mainLogic.bestellungPending.abholung.kundeTelefon =
              this.kundeTelefon
            this.mainLogic.bestellungPending.abholung.kundeEmail =
              this.kundeEmail

            router.push({ name: RouteNames.NEU.BESTAETIGEN_ABHOLUNG })
          } else {
            this.updateLoadState = LoadState.Error
          }
        })
        .catch(() => {
          this.updateLoadState = LoadState.Error
        })
    }
  }
}
